import api from './client';
import type { PowerPoint } from './inverterDetail';

export type StringCurrent = {
  inverter_string_power_plant_name: string;
  inverter_string_inverter_name: string;
  inverter_string_inverter_id: number;
  inverter_string_inverter_brand: string;
  inverter_string_inverter_model: string;
  inverter_string_inverter_serial_number: string;
  inverter_string_string_number: number;
  inverter_string_actual_current: number | null;
  inverter_string_actual_voltage: number | null;
  inverter_string_daily_current_avg: number | null;
  inverter_string_monthly_current_avg: number | null;
  inverter_string_yearly_current_avg: number | null;
  inverter_string_daily_voltage_avg: number | null;
  inverter_string_monthly_voltage_avg: number | null;
  inverter_string_yearly_voltage_avg: number | null;
  inverter_string_efficiency_according_to_other_strings: number | null;
  inverter_string_twin_string_number: number | null;
  inverter_string_twin_string_actual_current: number | null;
  inverter_string_twin_string_actual_voltage: number | null;
  inverter_string_twin_string_daily_current_avg: number | null;
  inverter_string_twin_string_monthly_current_avg: number | null;
  inverter_string_twin_string_yearly_current_avg: number | null;
  inverter_string_twin_string_daily_voltage_avg: number | null;
  inverter_string_twin_string_monthly_voltage_avg: number | null;
  inverter_string_twin_string_yearly_voltage_avg: number | null;
  inverter_string_twin_string_efficiency_according_to_other_strings: number | null;
  inverter_string_efficiency_according_to_twin_string: number | null;
  inverter_string_last_seen: string | null;
  inverter_string_status: 0 | 1;
};

export type StringCharts = {
  hourly: PowerPoint[];
  daily: PowerPoint[];
  monthly: PowerPoint[];
  yearly: PowerPoint[];
};

export type StringDetail = {
  current: StringCurrent;
  ipv: StringCharts;
  upv: StringCharts;
  pac: StringCharts;
};

export async function fetchStringDetail(inverterId: number, stringNumber: number): Promise<StringDetail> {
  const res = await api.get<StringDetail>(`/inverters/${inverterId}/string/${stringNumber}`);
  return res.data;
}
